import { InjectionToken } from '@angular/core'

export const ORDERED_APP_INITIALIZER = new InjectionToken<(() => any)[]>('Ordered Application Initializer')

export function orderedAppInitializer(appInits: (() => any)[]): () => Promise<void> {
  return async () => {
    for (const init of appInits) {
      const result = init()
      if (result && typeof result.then === 'function') {
        await result
      }
    }
  }
}
